import FlexColContent from './flex-col-content.vue';

export default FlexColContent;
